import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import posed from "react-pose";
import { ScreenHeader } from "../Layout";
import {
  TemperatureParameter,
  HumidityParameter,
  SnowParameter
} from "./Types";

const PoseOverlay = posed.div({
  open: {
    delayChildren: 250,
    staggerChildren: 50
  },
  closed: { delay: 500 }
});

const PoseItem = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: 100, opacity: 0 }
});

class Parameters extends PureComponent {
  static propTypes = {
    advisor: PropTypes.shape({
      region: PropTypes.number,
      sportType: PropTypes.number,
      sportVariant: PropTypes.number
    }),
    humidity: PropTypes.number.isRequired,
    temperature: PropTypes.number.isRequired,
    snowType: PropTypes.number.isRequired,
    onUpdate: PropTypes.func,
    onSubmit: PropTypes.func
  };

  static defaultProps = {
    fromSportVariant: false,
    onUpdate: () => {},
    onSubmit: () => {}
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    this.setState({ isOpen: true });
  }

  onSubmit = event => {
    event.preventDefault();
    this.props.onSubmit();
  };

  render() {
    const goBackIcon = () => {
      return (
        <Link
          to={
            this.props.advisor.sportVariant ? "/sport-variants" : "/sport-types"
          }
        >
          <i className="icon-back" />
        </Link>
      );
    };

    return (
      <div className="screen-container screen-parameters">
        <ScreenHeader title={this.props.t('parameters:screen_title')} left={goBackIcon()} />
        <PoseOverlay
          className="content"
          pose={this.state.isOpen ? "open" : "closed"}
        >
          <PoseItem className="param-wrap">
            <TemperatureParameter
              title={this.props.t('parameters:temperature').toUpperCase()}
              value={this.props.temperature}
              onValueChange={value => {
                this.props.onUpdate("temperature", value);
              }}
            />
          </PoseItem>

          <PoseItem className="param-wrap">
            <HumidityParameter
              title={this.props.t('parameters:air_humidity').toUpperCase()}
              value={this.props.humidity}
              onValueChange={value => {
                this.props.onUpdate("humidity", value);
              }}
            />
          </PoseItem>

          <PoseItem className="param-wrap">
            <SnowParameter
              title={this.props.t('parameters:snow_type').toUpperCase()}
              value={this.props.snowType}
              onValueChange={value => {
                this.props.onUpdate("snowType", value);
              }}
            />
          </PoseItem>

          <PoseItem className="action-wrap">
            <a
              href="#to-results"
              role="button"
              className="button"
              onClick={this.onSubmit}
            >
              <span>{this.props.t('parameters:show_results')}</span>
              <i className="icon-caret-right" />
            </a>
          </PoseItem>
        </PoseOverlay>
      </div>
    );
  }
}

export default withNamespaces(["parameters", "common"], { wait: true })(Parameters)
